// extracted by mini-css-extract-plugin
module.exports = {"infoSession":"home_infoSession__3TXXz"};